export const namespacedPrefix = '[GUIDE]';
